export default __webpack_public_path__ + "04af2fb7ccbf16df1aade1f9a57254ea.svg";